import React from "react";
import PlaysListD from "./PlaysListDesktop";
import PlaysList from "./PlaysListMobile";
import { useMediaQuery } from 'react-responsive'


export default function PlaysListResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <PlaysListD/>}
        {isMobileDevice && <PlaysList/>}  
      </div>
    )
}

